import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from "prop-types";

function Loading(props) {
    let marginPercentage = "20%";
    if (props.noMargin === "true") {
        marginPercentage = "2%";
    }
    return (
        <>
            <CircularProgress data-testid="loading-element" style={{ margin: marginPercentage }} />
        </>
    );
}

Loading.propTypes = {
    noMargin: PropTypes.any,
};

export default Loading;
